(function () {
  'use strict';

  var runtimePromise;

  function mount() {
    return document.getElementById('somml-container');
  }

  function setStaticBusy(isBusy) {
    var container = mount();
    if (!container) return;

    var controls = container.querySelectorAll('.boi-sommelier-static-control');
    controls.forEach(function (control) {
      control.disabled = isBusy;
      if (isBusy) control.setAttribute('aria-busy', 'true');
      else control.removeAttribute('aria-busy');
    });
  }

  function runLoadedAction(action) {
    window.requestAnimationFrame(function () {
      if (action && action.intent && typeof window.BoiSommelierSendIntent === 'function') {
        window.BoiSommelierSendIntent(action.intent, action.label || '');
        return;
      }

      var launcher = document.getElementById('somml-launcher');
      if (launcher) launcher.click();
    });
  }

  function loadSommelier(action) {
    if (runtimePromise) {
      return runtimePromise.then(function () {
        runLoadedAction(action);
      });
    }

    runtimePromise = new Promise(function (resolve, reject) {
      var container = mount();
      var runtimeUrl = container && container.getAttribute('data-runtime-url');
      if (!container || !runtimeUrl) {
        reject(new Error('Sommelier mount is unavailable'));
        return;
      }

      setStaticBusy(true);

      var script = document.createElement('script');
      script.src = runtimeUrl;
      script.async = true;
      script.dataset.boiSommelierRuntime = 'true';
      script.onload = function () {
        var staticWrapper = container.querySelector('.boi-sommelier-launcher-wrap');
        if (staticWrapper) staticWrapper.remove();
        resolve();
      };
      script.onerror = function () {
        runtimePromise = null;
        setStaticBusy(false);
        reject(new Error('Unable to load Sommelier runtime'));
      };
      document.head.appendChild(script);
    });

    return runtimePromise.then(function () {
      runLoadedAction(action);
    });
  }

  window.BoiLoadSommelier = loadSommelier;

  document.addEventListener('click', function (event) {
    if (!event.target) return;

    var bubble = event.target.closest('.boi-sommelier-static-bubble');
    if (bubble) {
      loadSommelier({
        intent: bubble.getAttribute('data-sommelier-intent'),
        label: bubble.textContent.trim()
      }).catch(function () {});
      return;
    }

    if (event.target.closest('#somml-launcher-placeholder')) loadSommelier().catch(function () {});
  });
})();
